import React, { useMemo } from 'react';

const MdForumContext = React.createContext({ subjectId: null, subjectType: null });

export default MdForumContext;

export function MdForumContextProvider({ subjectId, subjectType, children }) {
    const contextValue = useMemo(() => {
        return { subjectId, subjectType };
    }, [subjectId, subjectType]);
    return <MdForumContext.Provider value={contextValue}>{children}</MdForumContext.Provider>;
}
